import { getToken, removeToken, removeUser, setExpiry, setUser } from "../../utils/token";
import { AuthAPI } from "../../services/apiService";
import { setAuthToken } from "../../services/apiClient";

const login = async (credentials) => {
  const response = await AuthAPI.login(credentials);
  const resData = response?.data;

  // Resilient extraction based on known variants: access_token or token
  const token = resData?.access_token || resData?.token || resData?.data?.token || resData?.data?.access_token;
  const user = resData?.user || resData?.data?.user;

  // Role can be in current_role or role
  const apiRole = resData?.current_role || resData?.role || resData?.data?.current_role || resData?.data?.role;
  const rolesRaw = resData?.roles || resData?.data?.roles || user?.roles;
  const expiresIn = resData?.expires_in || resData?.data?.expires_in || resData?.expiresIn || resData?.data?.expiresIn;

  let roles = [];
  try {
    roles = typeof rolesRaw === "string" ? JSON.parse(rolesRaw) : (Array.isArray(rolesRaw) ? rolesRaw : []);
  } catch (e) {
    roles = [];
  }

  // If user selected a role, prefer that if it's valid, otherwise use apiRole
  const finalRole = roles.includes(credentials.selected_role)
    ? credentials.selected_role
    : apiRole || credentials.selected_role;

  if (token) {
    setAuthToken(token);
    if (expiresIn) setExpiry(expiresIn);
  }

  if (user) {
    setUser(user);
  }

  if (finalRole) {
    localStorage.setItem("role", finalRole);
  }

  return { token, user, role: finalRole, roles, expiresIn };
};

const register = async (data) => {
  const response = await AuthAPI.register(data);
  return response.data;
};

const requestOtp = async (data) => {
  const response = await AuthAPI.requestOtp(data);
  return response.data;
};

const verifyOtp = async (data) => {
  const response = await AuthAPI.verifyOtp(data);
  const resData = response?.data;
  const resNested = resData?.data;

  const token = resNested?.token || resData?.token || resData?.access_token || resNested?.access_token;
  const user = resNested?.user || resData?.user;
  const apiRole = resNested?.current_role || resNested?.role || resData?.current_role || resData?.role;
  const rolesRaw = resNested?.roles || resData?.roles;
  const expiresIn = resNested?.expires_in || resNested?.expiresIn || resData?.expires_in || resData?.expiresIn;

  let roles = [];
  try {
    roles = typeof rolesRaw === "string" ? JSON.parse(rolesRaw) : (Array.isArray(rolesRaw) ? rolesRaw : []);
  } catch (e) {
    roles = [];
  }

  const finalRole = roles.includes(data.role) ? data.role : (apiRole || data.role);

  if (token) {
    setAuthToken(token);
    if (expiresIn) setExpiry(expiresIn);
    if (finalRole) localStorage.setItem("role", finalRole);
  }

  return { token, user, role: finalRole, roles, expiresIn };
};

const verifyLoginOtp = async (data) => {
  const response = await AuthAPI.verifyLoginOtp(data);
  const resData = response?.data;
  const resNested = resData?.data;

  const token = resNested?.token || resData?.token || resData?.access_token || resNested?.access_token;
  const user = resNested?.user || resData?.user;
  const apiRole = resNested?.role || resNested?.current_role || resData?.role || resData?.current_role;
  const rolesRaw = resNested?.roles || resData?.roles;
  const expiresIn = resNested?.expires_in || resNested?.expiresIn || resData?.expires_in || resData?.expiresIn;

  let roles = [];
  try {
    roles = typeof rolesRaw === "string" ? JSON.parse(rolesRaw) : (Array.isArray(rolesRaw) ? rolesRaw : []);
  } catch (e) {
    roles = [];
  }

  const finalRole = roles.includes(data.role) ? data.role : (apiRole || data.role);

  if (token) {
    setAuthToken(token);
    if (expiresIn) setExpiry(expiresIn);
    if (finalRole) localStorage.setItem("role", finalRole);
  }

  return { token, user, role: finalRole, roles, expiresIn };
};

const resendOtp = async (data) => {
  const response = await AuthAPI.resendOtp(data);
  return response.data;
};

const resendVerification = async (data) => {
  const response = await AuthAPI.resendVerification(data);
  return response.data;
}

const forgotPassword = async (data) => {
  const response = await AuthAPI.forgotPassword(data);
  return response.data;
};

const resetPassword = async (data) => {
  const response = await AuthAPI.resetPassword(data);
  return response.data;
};

const getProfile = async () => {
  const response = await AuthAPI.getProfile();
  return response.data;
};

const logout = async () => {
  const token = getToken();
  if (token) {
    try {
      await AuthAPI.logout();
    } catch (error) {
      console.log("Server session already cleared or expired.");
    }
  }
  removeToken();
  removeUser();
  // Cleanup axios headers
  setAuthToken(null);
};

export const authService = {
  login,
  register,
  requestOtp,
  verifyOtp,
  verifyLoginOtp,
  resendOtp,
  resendVerification,
  forgotPassword,
  resetPassword,
  getProfile,
  logout,
};
